import { render, staticRenderFns } from "./ConfirmationCard.vue?vue&type=template&id=22884d2d&"
import script from "./ConfirmationCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports